// extracted by mini-css-extract-plugin
export var background = "_5c-0";
export var container = "_5c-1";
export var contentItem = "_5c-7";
export var extendedWarranty = "_5c-5";
export var link = "_5c-d";
export var modal = "_5c-b";
export var modalCloseButton = "_5c-9";
export var modalContent = "_5c-3";
export var modalContentMain = "_5c-6";
export var modalImageLogo = "_5c-8";
export var modalLogo = "_5c-a";
export var modalSideImage = "_5c-4";
export var preview = "_5c-c";
export var redoModal = "_5c-2";